import { marked } from 'marked';
import { baseUrl } from '../App';

export default function About({content}) {
    const sisutekst = {__html: marked.parse(content.sisutekst)}
    const aboutImageUrl = baseUrl + content.pilt.data.attributes.url
    return (
        <div id="Meist" className="about">
            <div className="about-photo" style={{backgroundImage: `url(${aboutImageUrl})`}}></div>
            <div className="about-text">
                <h3 className="about-title">{content.pealkiri}</h3>
                <div className="about-body" dangerouslySetInnerHTML={sisutekst}></div>
            </div>
        </div>
    )
}